import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export function TooManyWrongCodesDialog() {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'alert'} />}}>
                Too many wrong codes
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                You&#39;ve entered the wrong code 3 times. Request&nbsp;a&nbsp;new one to continue.
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'secondary'}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
